import { AlertCircle, RotateCcw } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router-dom';
import { Button } from '@/Domain/components/Shared/Button/Button';

/** Without this the route falls through to NotFound, which redirects instead of rendering. */
export const GettingStartedError = () => {
  const { t } = useTranslation('getting_started');
  const navigate = useNavigate();
  const error = useRouteError();

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('Getting Started route error', error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6">
      <div
        role="alert"
        data-testid="gs-route-error"
        className="flex max-w-lg flex-col items-center gap-4 rounded-2xl border border-destructive/20 bg-card p-6 text-center"
      >
        <div className="flex size-12 items-center justify-center rounded-xl bg-destructive/10">
          <AlertCircle className="size-6 text-destructive" />
        </div>
        <div className="space-y-1.5">
          <h2 className="text-lg font-semibold text-foreground">
            {t('automatic_flow.error_title')}
          </h2>
          <p className="text-sm text-muted-foreground">{t('error.description')}</p>
        </div>
        <Button
          variant="dark"
          size="md"
          onClick={() => navigate(0)}
          data-testid="gs-route-error-retry"
        >
          <RotateCcw className="size-4" />
          {t('automatic_flow.error_retry')}
        </Button>
      </div>
    </div>
  );
};
